<template>
  <div class="highlights-selected-products-container">
    <span class="products-title"><b>Produtos destacados</b> (opcional)</span>
    <span class="products-description">
      Selecione quais produtos vão estar na capa do modelo de destaque. O limite é de {{ selectableItemsLimit }} produtos. Se não selecionados, eles serão
      escolhidos aleatoriamente.
    </span>
    <chip-list
      allow-select-items
      dialog-title="Produtos destacados"
      dialog-width="874px"
      :dialog-description="dialogDescription"
      details-type="dialog"
      variant="products"
      button-activator
      button-activator-label="Selecionar produtos destacados"
      :selected-items-limit="selectableItemsLimit"
      :headers="headers"
      :products="selectableItems"
      :items="formattedSelectedItems"
      :selected-items.sync="selectedItems"
      :disable-items-selection="finishedHighlight"
      :disabled="finishedHighlight"
    />
  </div>
</template>

<script>
import { highlightOffer } from '../../../../mixins/highlight-offer'

export default {
  name: 'SelectedProducts',
  components: {
    ChipList: () => import('@/components/ChipList.vue'),
  },
  mixins: [highlightOffer],
  props: {
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    openProductsDialog: false,
    selectedItems: [],
  }),
  computed: {
    items() {
      const products = (this.highlightOffer.products || []).map((p) => ({
        ...p,
        isGroup: false,
        select: p?.showHome,
      }))

      const groups = (this.highlightOffer.productsGroups || []).map((g) => ({
        ...g,
        sku: `group-${g.product_group_id ?? g.id ?? g.name}`,
        name: g.name || 'Grupo sem nome',
        image: g.image_url || '',
        ean: '',
        isGroup: true,
        select: g?.showHome,
      }))

      const allItems = [...products, ...groups]

      return this.highlightOffer.id ? allItems.map((i) => ({ ...i, select: i?.showHome })) : allItems
    },

    finishedHighlight() {
      return this.highlightStatus === 'FINISHED'
    },

    selectableItems() {
      const selectedSkus = this.selectedItems.map((i) => i.sku)
      return this.items.map((i) => ({
        ...i,
        isSelectable: !(selectedSkus.length >= this.selectableItemsLimit && !selectedSkus.includes(i.sku)),
      }))
    },

    selectableItemsLimit() {
      return this.isExpandedModel ? 2 : 4
    },

    dialogDescription() {
      return `Selecione quais produtos vão estar na capa do modelo de destaque. O limite é de ${this.selectableItemsLimit} produtos na capa. Caso a quantidade máxima não seja atingida, os produtos serão dispostos de forma aleatória.`
    },

    formattedSelectedItems() {
      return this.selectedItems.map((i) => (i.isGroup ? i.name : `${i.sku} - ${i.name}`))
    },

    headers() {
      return [
        { text: '', value: 'select', width: '10%', sortable: false },
        { text: '', value: 'image', width: '10%' },
        { text: 'SKU', value: 'sku', width: '12%' },
        { text: 'EAN', value: 'ean', width: '18%' },
        { text: 'Nome', value: 'name', width: '45%' },
      ]
    },
  },

  watch: {
    selectedItems(newVal) {
      const selectedSkus = newVal.map((i) => i.sku)

      const products = (this.highlightOffer.products || []).map((p) => ({
        ...p,
        showHome: selectedSkus.includes(p.sku),
      }))

      const productsGroups = (this.highlightOffer.productsGroups || []).map((g) => ({
        ...g,
        showHome: selectedSkus.includes(`group-${g.product_group_id ?? g.id ?? g.name}`),
      }))

      this.setHighlightKeyValue({ payload: products, key: 'products' })
      this.setHighlightKeyValue({ payload: productsGroups, key: 'productsGroups' })
    },
  },

  mounted() {
    const selectedProducts = (this.highlightOffer.products || []).filter((p) => p.showHome)

    const selectedGroups = (this.highlightOffer.productsGroups || [])
      .filter((g) => g.showHome)
      .map((g) => ({
        ...g,
        sku: `group-${g.product_group_id ?? g.id ?? g.name}`,
        name: g.name || 'Grupo sem nome',
        image: g.image_url || '',
        ean: '',
        isGroup: true,
      }))

    this.selectedItems = [...selectedProducts, ...selectedGroups].map((i) => ({
      ...i,
      isSelectable: true,
    }))
  },
}
</script>

<style lang="scss" scoped>
.highlights-selected-products-container {
  display: flex;
  flex-direction: column;
  gap: 16px;

  .products-title {
    color: $cinza-d10;
    font-weight: 400;
    font-size: 18px;

    b {
      font-weight: 700;
    }
  }

  .products-description {
    color: #656565;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 120%;
    letter-spacing: 0.4px;
  }
}
</style>
